<template>
<div class="card-header">         
  <div class="header">
    <h6 class="card-subtitle float-left" :class="type">{{ title }}</h6> 
    <b-icon v-if="close" icon="x" class="mb-0 close_icon"  width="2em" height="2em" :title="$t('button.close')" @click='onClose'></b-icon>
  </div>
  <hr v-if="hr"/>
</div>
</template>

<script>
export default {
  name: 'CardHeader',
  props: {
    title: { default: "" },
    close: { default: false },
    type:  { default: "default" },
    hr: { default: false }
  },
  data() {
    return {
      filter: null
    }
  },
  methods: {
    onClose() {
      this.$emit('close', this.filter);
    }
 }
}
</script>

<style scoped lang="scss">
.card-header .header {
  display:flex;
  justify-content: space-between;
  margin-bottom: 0.5em;
}

.card .card-header {
    margin-left: 0;
    padding: 0;
   margin-bottom:0.5em
}
.card-header h6 {
    padding-top: 8px;
    font-size: 18px;
    color: #6c757d;
}
.close_icon {
  color: rgb(78, 78, 78);
  float: right;
}
hr {
  margin:5; 
  border: 1px solid;
  //color: rgba(100, 100, 100, 0.5);
  color: #f1eae0;
}

</style>